var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9024 0C26.048 0 28.112 0.824444 29.6304 2.30378C31.1504 3.78 32 5.77111 32 7.85556V20.1444C32 24.4844 28.368 28 23.9024 28H8.096C3.6304 28 0 24.4844 0 20.1444V7.85556C0 3.51556 3.6144 0 8.096 0H23.9024ZM26.4477 10.1734L26.5757 10.0489C26.9581 9.59784 26.9581 8.9445 26.5581 8.49339C26.3357 8.26161 26.0301 8.12006 25.7117 8.08895C25.3757 8.07184 25.0557 8.18228 24.8141 8.40006L17.5997 14.0001C16.6717 14.7483 15.3421 14.7483 14.3997 14.0001L7.19969 8.40006C6.70209 8.04228 6.01409 8.08895 5.59969 8.50895C5.16769 8.92895 5.11969 9.59784 5.48609 10.0645L5.69569 10.2667L12.9757 15.7889C13.8717 16.4734 14.9581 16.8467 16.0957 16.8467C17.2301 16.8467 18.3357 16.4734 19.2301 15.7889L26.4477 10.1734Z",
    fill: "#D3B474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.9f1de40597a2c18bfdfa7d876751d171.svg";
export { ForwardRef as ReactComponent };